function e(e, t) {
  if (null == e) return {};
  var n,
      r,
      o = {},
      u = Object.keys(e);

  for (r = 0; r < u.length; r++) {
    t.indexOf(n = u[r]) >= 0 || (o[n] = e[n]);
  }

  return o;
}

var t = ["onboard"],
    n = ["uauth", "shouldLoginWithRedirect"];

if ("undefined" != typeof window) {
  var r = window;
  r.UAUTH_VERSION = r.UAUTH_VERSION || {}, r.UAUTH_VERSION.BNC_ONBOARD = "2.4.0";
}

var o = /*#__PURE__*/function () {
  function r(e) {
    this.options = void 0, this._uauth = void 0, this.options = e;
  }

  r.registerUAuth = function (e) {
    r.UAuth = e;
  }, r.importUAuth = function () {
    try {
      var e = function () {
        if (null == r.UAuth) return Promise.resolve(import("@uauth/js").then(function (e) {
          var t;
          return null != (t = null == e ? void 0 : e.default) ? t : e;
        })).then(function (e) {
          r.UAuth = e;
        });
      }();

      return Promise.resolve(e && e.then ? e.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var o,
      u,
      i = r.prototype;
  return i.getUAuth = function () {
    try {
      var e = this;
      return Promise.resolve(r.importUAuth()).then(function () {
        return e.uauth;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, i.callbackAndWalletSelect = function (n) {
    var o = n.onboard,
        u = e(n, t);

    try {
      var i = this;
      return Promise.resolve(r.importUAuth()).then(function () {
        function e() {
          return o.walletSelect("Unstoppable");
        }

        var t = u.url ? Promise.resolve(i.uauth.loginCallback(u)).then(function () {}) : Promise.resolve(i.uauth.loginCallback()).then(function () {});
        return t && t.then ? t.then(e) : e();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, i.module = function (e) {
    var t = this,
        n = e.preferred,
        o = void 0 === n || n,
        u = e.walletconnect;
    return {
      desktop: !0,
      mobile: !0,
      preferred: "boolean" != typeof o || o,
      type: "sdk",
      name: "Unstoppable",
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.7319 2.06934V9.87229L0 19.094L22.7319 2.06934Z" fill="#2FE9FF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.4696 1.71387V15.1917C18.4696 19.1094 15.2892 22.2853 11.3659 22.2853C7.44265 22.2853 4.26221 19.1094 4.26221 15.1917V9.51682L8.52443 7.17594V15.1917C8.52443 16.5629 9.63759 17.6745 11.0107 17.6745C12.3839 17.6745 13.497 16.5629 13.497 15.1917V4.4449L18.4696 1.71387Z" fill="#4C47F7"/></svg>',
      wallet: function wallet(e) {
        var n = e.createLegacyProviderInterface,
            o = e.createModernProviderInterface,
            i = e.resetWalletState;

        try {
          return Promise.resolve(r.importUAuth()).then(function () {
            var e;

            function r(r) {
              var a;

              function l(e) {
                var r = a ? "function" == typeof a.enable ? o(a) : n(a) : null;
                return r && (r.name = "Unstoppable"), {
                  provider: a,
                  interface: r,
                  instance: t.uauth
                };
              }

              if (!e.wallet_type_hint) throw new Error("no wallet type hint");

              var c = function () {
                if (!["web3", "injected"].includes(e.wallet_type_hint)) return function () {
                  if ("walletconnect" === e.wallet_type_hint) return Promise.resolve(import("@walletconnect/web3-provider")).then(function (e) {
                    return (a = new (0, e.default)(u)).autoRefreshOnNetworkChange = !1, a.wc.on("disconnect", function () {
                      t.uauth.logout({
                        rpInitiatedLogout: !1
                      }), i({
                        disconnected: !0,
                        walletName: "Unstoppable"
                      });
                    }), Promise.resolve(a.enable()).then(function () {});
                  });
                  throw new Error("Should never reach here!");
                }();
                a = window.ethereum || window.web3 && window.web3.currentProvider;
              }();

              return c && c.then ? c.then(l) : l();
            }

            var a = function (n, r) {
              try {
                var o = Promise.resolve(t.uauth.user()).then(function (t) {
                  e = t;
                });
              } catch (e) {
                return r();
              }

              return o && o.then ? o.then(void 0, r) : o;
            }(0, function () {
              if (!t.uauth.fallbackLoginOptions.scope.includes("wallet")) throw new Error('Must request the "wallet" scope for connector to work.');
              return t.options.shouldLoginWithRedirect ? Promise.resolve(t.uauth.login({
                packageName: "@uauth/bnc-onboard",
                packageVersion: "2.4.0"
              })).then(function () {
                return Promise.resolve(new Promise(function () {})).then(function () {
                  throw new Error("Should never get here.");
                });
              }) : Promise.resolve(t.uauth.loginWithPopup({
                packageName: "@uauth/bnc-onboard",
                packageVersion: "2.4.0"
              })).then(function () {
                return Promise.resolve(t.uauth.user()).then(function (t) {
                  e = t;
                });
              });
            });

            return a && a.then ? a.then(r) : r();
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }
    };
  }, o = r, (u = [{
    key: "uauth",
    get: function get() {
      var t = this.options,
          o = t.uauth,
          u = e(t, n);
      if (this._uauth) return this._uauth;
      if (o) return o;
      if (null == r.UAuth) throw new Error("Must import UAuth before constructing a UAuth Object");
      if (!u.clientID || !u.redirectUri) throw new Error("Incomplete constructor options");
      return this._uauth = new r.UAuth(u), this._uauth;
    }
  }]) && function (e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }(o.prototype, u), Object.defineProperty(o, "prototype", {
    writable: !1
  }), r;
}();

o.UAuth = void 0;
export { o as default };